
<div class="container background inset"  *ngIf="allState" [@backgroundTrigger]="backgroundState"  >
    <img alt="lesson header bar image" data-src={{lessonCard?.img}} class="titleImage" [@imageTrigger]="imageState">
    <div class="inner">
      <h4 >{{config?.guide}} {{lessonCard?.id}}</h4>
      <h1 >{{lessonCard?.title}}</h1>
    </div>
</div>
